import type { WebsiteBlock } from '../../types'
import { useBranding } from '../../contexts/BrandingContext'
import { useI18n } from '../../i18n'

interface TeamProps {
  title: string
  titleEn?: string
  members: Array<{
    name: string
    nameEn?: string
    role: string
    roleEn?: string
    avatarUrl?: string
  }>
}

export default function TeamBlock({ block }: { block: WebsiteBlock }) {
  const { branding } = useBranding()
  const { lang } = useI18n()
  const p = block.props as TeamProps

  const title = lang === 'en' && p.titleEn ? p.titleEn : p.title
  const hasContent = title?.trim() || (p.members && p.members.length > 0)
  if (!hasContent) return null

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        {title?.trim() && (
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 tracking-tight" style={{ color: branding.secondaryColor }}>
            {title}
          </h2>
        )}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {(p.members || []).map((m, i) => (
            <div key={i} className="text-center p-4">
              {m.avatarUrl ? (
                <img src={m.avatarUrl} alt="" className="w-20 h-20 rounded-full mx-auto mb-3 object-cover" />
              ) : (
                <div className="w-20 h-20 rounded-full mx-auto mb-3 flex items-center justify-center text-white text-xl font-medium"
                  style={{ backgroundColor: `${branding.primaryColor}30`, color: branding.primaryColor }}>
                  {(lang === 'en' && m.nameEn ? m.nameEn : m.name)?.[0] || 'U'}
                </div>
              )}
              <p className="text-sm font-medium" style={{ color: branding.secondaryColor }}>
                {lang === 'en' && m.nameEn ? m.nameEn : m.name}
              </p>
              <p className="text-xs text-gray-400 mt-0.5">
                {lang === 'en' && m.roleEn ? m.roleEn : m.role}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
